import { useEffect, useMemo, useState } from "react";
import AuthService from "../../../modules/Admin/services/AuthService";
import { isModuleEnabled, ensureModuleAccessLoaded } from "../../utils/moduleAccessStore";
import SidebarBrand from "../../components/SidebarBrand";
import AppShell from "../../layout/AppShell";
import { adminMenuGroups, filterMenuGroups } from "../../layout/sidebarMenuConfigs";
import { isSuperAdminRole } from "../../../routes/roles";

const SideBar = ({ children }) => {
  const roleId = AuthService.getLoggedInRoleId();
  const [moduleAccessTick, setModuleAccessTick] = useState(0);
  const [agency, setAgency] = useState(null);
  const ClientId = AuthService.getLoggedInClientId();

  useEffect(() => {
    if (isSuperAdminRole(roleId)) return undefined;
    let cancelled = false;
    ensureModuleAccessLoaded().then(() => {
      if (!cancelled) setModuleAccessTick((t) => t + 1);
    });
    return () => {
      cancelled = true;
    };
  }, [roleId]);

  useEffect(() => {
    async function getAgencyLogoByClientId() {
      try {
        const response =
          await AuthService.getAgencyLogoAndNameByClientId(ClientId);
        setAgency(response);
      } catch (error) {
        console.error("Error fetching agency:", error);
      }
    }
    getAgencyLogoByClientId();
  }, [ClientId]);

  const menuGroups = useMemo(
    () =>
      filterMenuGroups(adminMenuGroups, {
        roleId,
        isModuleEnabled,
        hidePaths: isSuperAdminRole(roleId) ? [] : ["/notification-engine"],
      }),
    [roleId, moduleAccessTick],
  );

  return (
    <AppShell
      menuGroups={menuGroups}
      sidebarHeader={
        <SidebarBrand to="/dashboard" agency={agency} variant="sidebar" />
      }
    >
      {children}
    </AppShell>
  );
};

export default SideBar;
